import { createElement, type ReactElement } from 'react'
import { ElementPin } from '../../lib/mapMarkers'

/**
 * Contenido JSX del marcador de cambio de estado de un traslado (pin estándar
 * de evento con el color del estado + etiqueta debajo). Se usa como hijo de
 * `<AdvancedMarker>` de Google Maps.
 */
export function createStateIcon(color: string, label: string): ReactElement {
  return createElement(
    'div',
    { style: { display: 'flex', flexDirection: 'column', alignItems: 'center' } as const },
    createElement(ElementPin, { kind: 'stateEvent', color, size: 30 }),
    createElement(
      'div',
      {
        style: {
          marginTop: 2,
          padding: '2px 6px',
          background: 'white',
          color,
          fontSize: 10,
          fontWeight: 700,
          borderRadius: 4,
          border: `1px solid ${color}`,
          whiteSpace: 'nowrap',
          boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
        } as const,
      },
      label,
    ),
  )
}
